<template>
  <div v-if="load < 1">
    <LoaderCar width="600px" marginTop="0"/>
  </div>
  <div class="background" v-else>
    <HeaderConduitePlanning :eleve="eleve" ref="headRefHeader" :acc="eleve.acc" @setDispoMobile="setDispoMobile" @setResa="setResa" @setupMonoChoice="setupMonoChoice" @setupLieuDispo="setupLieuDispo" @setDisplayResaDispo="setDisplayResaDispo" @getEleveInfo="getEleveInfo"/>
    <template v-if="this.$store.state.showMonoElevePage == true">
      <Moniteurs
        :eleve="eleve"
        :choixDispo="eleve.choixDispo[0]"
        @getEleveInfo="getEleveInfo"
        :modalChoixEleve="false"
      />
    </template>
    <template v-else>
      <PlanningConduite
        :eleve="eleve"
        @getEleveInfo="getEleveInfo"
        @clearValuesResa="clearValuesResa"
        @resetMono="resetMono"
        @showAccDiag="this.$refs.headRefHeader.showAccDiag()"
        ref="headRef"
      />
    </template>
  </div>
</template>

<script>
import HeaderConduitePlanning from "@/components/eleve/conduite/HeaderConduitePlanning.vue";
import Moniteurs from "@/components/eleve/conduite/Moniteurs.vue";
import PlanningConduite from "@/components/eleve/conduite/PlanningConduite.vue";
import LoaderCar from "@/components/LoaderCar.vue";
import { ref } from "vue";

export default {
  setup() {
    const headRef = ref();
    const headRefHeader = ref();

    const setDisplayResaDispo = (show) => headRef.value.setDisplayResaDispo(show);
    const setupLieuDispo = (lieuSelec) => headRef.value.setupLieuDispo(lieuSelec);
    const setupMonoChoice = (mono) => headRef.value.setupMonoChoice(mono);
    const setDispoMobile = (dateDispo, heureDeb, heureFin, lieu) => headRef.value.setDispoMobile(dateDispo, heureDeb, heureFin, lieu);
    const setResa = () => headRef.value.setResa();
    const clearValuesResa = () => headRefHeader.value.clearValuesResa();
    const resetMono = () => headRefHeader.value.resetMono();

    return {
      headRef,
      headRefHeader,
      setDisplayResaDispo,
      setupLieuDispo,
      setupMonoChoice,
      setResa,
      clearValuesResa,
      resetMono,
      setDispoMobile
    };
  },

  props: [],

  components: {
    HeaderConduitePlanning,
    Moniteurs,
    LoaderCar,
    PlanningConduite,
  },

  watch: {},

  data() {
    return {
      load: 0,
      eleve: null,
    };
  },

  mounted() {
    this.getEleveInfo();
  },

  methods: {
    getEleveInfo() {
      window.api
        .get("/eleve/conduite/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.eleve = response.data.eleve[0];
          this.eleve.rdvs = [];
          this.eleve.apointments.forEach(a => {
            this.eleve.rdvs.push(a);
          });

          this.eleve.exams.forEach(e => {
            this.eleve.rdvs.push(e);
          })

          this.eleve.examBlancs.forEach(eb => {
            this.eleve.rdvs.push(eb);
          })

          this.load = this.load + 1;
          if (this.eleve.choixDispo == "null") {
            this.$store.commit("setShowMonoElevePage", true);
          }
          this.$store.commit("setElevePlanningInfo", this.eleve);

        })
        .catch((error) => {
          console.log(error);
        });
    },

  },
};
</script>

<style scoped>
div.background {
  background: #f4f6f9;
  min-height: 100vh;
}
</style>
